import React from 'react';
// import { MessageSquare } from 'lucide-react';
import yinhao from '@/imgs/CustomerNeedsRecognition/yinhao.png';
interface CustomerNeedsRecognitionProps {
  userQuestion?: string;
  extractedNeeds?: string;
  activeLabel?: string;
}

const CustomerNeedsRecognition: React.FC<CustomerNeedsRecognitionProps> = ({
  userQuestion = '',
  extractedNeeds = '',
  activeLabel = ''
}) => {
  return (
    <div
      className="mb-3 space-y-3 rounded-lg p-3"
      style={{
        background: 'linear-gradient(265deg, #F7FAFF 12.58%, #FFFCFC 87.65%)',
        boxShadow: 'inset 0 4px 4px 0 rgba(255, 255, 255, 0.67)'
      }}
    >
      {/* 用户问题卡片 */}
      <div
        className="rounded-lg border p-3"
        style={{
          background: 'linear-gradient(267deg, #EEEDFF 4.19%, #F6F7FF 86.14%)'
        }}
      >
        <div className="flex gap-2.5">
          {/* 引号图标 */}
          <div className="h-6 w-6 overflow-hidden">
            <img src={yinhao} alt="引号" className="h-full w-full object-cover" />
          </div>
          {/* 用户问题文本 */}
          <div className="flex-1">
            <p className="text-left text-xs leading-relaxed text-[#1F1F1F]">{userQuestion}</p>
          </div>
        </div>
      </div>

      {/* 需求提取区域 */}
      <div className="space-y-1">
        <h3 className="text-left text-sm font-semibold text-[#1F1F1F]">需求提取</h3>

        {/* 提取结果卡片 */}
        <div
          className="rounded-lg p-3"
          style={{
            border: '1px solid #3215F3',
            background: 'linear-gradient(267deg, #EEEDFF 4.19%, #F6F7FF 86.14%)',
            boxShadow: '0 4px 4px 0 rgba(255, 255, 255, 0.67) inset'
          }}
        >
          <p className="text-left text-xs leading-relaxed text-[#1F1F1F]">
            {activeLabel}：<span className="font-semibold text-[#5959EB]">{extractedNeeds}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CustomerNeedsRecognition;
